import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ContractPage() {
  const printRef = useRef();

  const [data, setData] = useState({
    date: "",
    companyRep: "",
    driverName: "",
    driverAddress: "",
    idNumber: "",
    licenseNumber: "",
    jobType: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      {/* Print Button */}
      <div className="mb-3 d-flex justify-content-end gap-2 d-print-none">
        <button type="button" className="btn btn-primary" onClick={handlePrint}>
          Print / Save PDF
        </button>
      </div>

      <div className="row g-4">
        {/* LEFT FORM */}
        <div className="col-12 col-lg-5 d-print-none">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title mb-3">Driver & Contract Details</h5>

              <div className="mb-3">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={data.date}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Company Representative</label>
              </div>

              <div className="mb-3">
                <label className="form-label">Driver Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="driverName"
                  value={data.driverName}
                  onChange={handleChange}
                  placeholder="e.g. John Doe"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Driver Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="driverAddress"
                  value={data.driverAddress}
                  onChange={handleChange}
                  placeholder="Street, City"
                />
              </div>

              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label">ID/Passport No.</label>
                  <input
                    type="text"
                    className="form-control"
                    name="idNumber"
                    value={data.idNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">License No.</label>
                  <input
                    type="text"
                    className="form-control"
                    name="licenseNumber"
                    value={data.licenseNumber}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* JOB TITLE (USER INPUT) */}
              <div className="mt-3">
                <label className="form-label">Job Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="jobType"
                  value={data.jobType}
                  onChange={handleChange}
                  placeholder="e.g. Minijob, Fahrer, Teilzeit, Uber Driver"
                />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT PREVIEW */}
        <div className="col-12 col-lg-7">
          <div ref={printRef} className="card p-4 shadow-sm h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h1 className="h4 m-0">DRIVER SERVICE CONTRACT</h1>

                <span className="badge text-bg-dark">
                  {data.jobType || "-"}
                </span>
              </div>

              <hr />

              <p className="mb-3">
                This Fahrlux Service Contract is made on{" "}
                <strong>{data.date || "[Date]"}</strong> between{" "}
                <strong>Fahrlux Hanau</strong>, represented by{" "}
                <strong>{"Fardin Azimi"}</strong>, and the Employee{" "}
                <strong>{data.driverName || "[Driver Name]"}</strong>, residing
                at <strong>{data.driverAddress || "[Address]"}</strong> with ID/
                Passport No. <strong>{data.idNumber || "[ID]"}</strong> and
                License No. <strong>{data.licenseNumber || "[License]"}</strong>
                .
              </p>

              <p className="mb-3">
                The Driver agrees to provide safe and professional
                transportation services on behalf of{" "}
                <strong>Fahrlux Hanau</strong>, following all German traffic
                laws and ensuring high customer service standards. The Driver
                acts as an independent contractor and is responsible for their
                own tax and insurance obligations unless otherwise required by
                law.
              </p>

              <p className="mb-3">
                The Driver must maintain a valid driving license, required
                passenger transport permissions if applicable, and a roadworthy
                vehicle with valid TÜV and insurance. The vehicle must always be
                clean and safe.
              </p>

              <p className="mb-3">
                Payment will be made based on agreed commission or fixed rate
                and processed weekly, bi-weekly, or monthly. The Company will
                provide transparent earnings statements.
              </p>

              <p className="mb-3">
                The Driver must treat passengers respectfully, avoid misconduct,
                and immediately report any incidents. Serious violations may
                result in immediate termination of this agreement.
              </p>

              <p className="mb-4">
                Either party may terminate this contract with 14–30 days notice,
                except in cases of serious breach. All company data must remain
                confidential.
              </p>

              <p className="mb-4">
                This agreement is governed by the laws of Germany. By signing,
                both parties confirm acceptance of all terms.
              </p>

              {/* SIGNATURES */}
              <div className="row row-cols-1 row-cols-md-2 g-4 mt-2">
                <div className="col">
                  <p className="fw-bold">Fahrlux Hanau</p>
                  <p>Name: __________________</p>
                  <p>Signature: _____________</p>
                  <p>Date: _________________</p>
                </div>

                <div className="col">
                  <p className="fw-bold">Driver</p>
                  <p>
                    Name:{" "}
                    <strong>{data.driverName || "__________________"}</strong>
                  </p>
                  <p>Signature: _____________</p>
                  <p>Date: _________________</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
